<template>
    <div id="flow-list-search" class="flow-list-search">
        <van-form>
            <div class="round-corner">
                <van-field
                        autofocus
                        v-model="searchJson.title"
                        name="标题"
                        label="标题"
                        placeholder="事项标题"
                />
                <van-field
                        v-if="receive"
                        v-model="searchJson.starterName"
                        name="姓名"
                        label="姓名"
                        placeholder="发起人姓名"
                />
                <van-field
                        v-if="receive"
                        v-model="searchJson.starter"
                        name="学工号"
                        label="学工号"
                        placeholder="发起人学工号"
                />
                <!--
                <van-field
                    v-model="starterUnit"
                    name="部门"
                    label="部门"
                    placeholder="请输入发起人部门"
                />
                -->

                <template v-if="!draft">
                    <van-field
                            readonly
                            clickable
                            name="calendar"
                            :value="parsedDate"
                            label="日期"
                            placeholder="发起日期区间"
                            @click="showCalendar = true"
                    />
                    <van-calendar v-model="showCalendar" type="range"
                                  color="#3fb0fb"
                                  :min-date="new Date('1970/01/01')"
                                  @confirm="onCalenderConfirm"/>
                </template>

                <template v-if="!draft">
                    <van-field name="radio" label="状态">
                        <template #input>
                            <van-radio-group v-model="searchJson.cooperative_tstatus" direction="horizontal">
                                <van-radio v-for="(status, index) in statusArr" :key="index" :name="status.id">
                                    {{status.text}}
                                </van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                </template>
            </div>
            <div class="form-box">
              <template v-if="formList.length>1">
                <h4>表单属性</h4>
                <van-tabs id="formBoxItem" v-model="tabActive" @change="tabsChange">
                  <van-tab v-for="(item,index) in formList" :title="item.cnname" :key="index"></van-tab>
                </van-tabs>
              </template>
              <template>
                <h4 @click="wordsOpen">表单字段<i></i></h4>
                <ul v-if="fixList">
                  <li v-for="(item,index) in fixList" :key="index">
                    <label>{{item.name}}</label>
                    <van-field
                        class="tj-field"
                        readonly
                        clickable
                        name="picker"
                        size="middle"
                        :value="item.logicrelationName"
                        placeholder="条件"
                        @click="openPicker(index)"
                    />
                    <van-field
                        class="tjz-field"
                        size="middle"
                        v-model="item.value"
                        v-if="item.field_type != 'd' && item.field_type != 'dt'"
                        name="条件值"
                        placeholder="条件值"
                    />
                    <van-field
                        class="tjz-field"
                        size="middle"
                        v-model="item.value"
                        v-else
                        name="条件值"
                        placeholder="条件值"
                        @click="openTimePicker(index)"
                    />
                  </li>
                </ul>
              </template>
            </div>
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
              />
            </van-popup>
            <van-popup v-model="showTimePicker" position="bottom">
              <van-datetime-picker
                  v-model="currentDate"
                  :type="datePickerType"
                  @confirm="onTimeConfirm"
                  @cancel="showTimePicker = false"
              />
            </van-popup>
            <div style="margin: 16px;">
                <van-button block type="info" @click="onSubmit">搜索</van-button>
            </div>
        </van-form>
        <div class="word-selector" v-show="selectWords">
          <div class="form-words-box">
            <span v-for="(item, index) in wordsList" :key="index" :class="{'selected': selectWordIds.indexOf(item.field) != -1}" @click="wordHandle(item)">{{item.name}}</span>
          </div>
          <div class="btn-box">
            <van-button color="#cccccc" @click="reset">重置</van-button>
            <van-button color="var(--main-color)" @click="fixHandle">确定</van-button>
          </div>
        </div>
    </div>
</template>

<script>
    import {Form, RadioGroup, Radio, Calendar, Field, Button, Popup, Picker, DatetimePicker, Toast} from 'vant'
    import {formatDateTime} from "@/utils/dateTimeUtil"
    import { getFormList, getWordsList } from "@/api/flow"
    export default {
        name: 'FlowListSearch',
        components: {
            [Form.name]: Form,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Field.name]: Field,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker,
            [Toast.name]: Toast
        },
        props: ['flowId', 'type', 'flowKey', 'innerSearchJson', 'searchFieldJson'],
        data() {
            return {
              searchJson: {
                title: '',
                starter: '',
                starterName: '',
                starterUnit: '',
                cooperative_tstatus: '',
                formDate: '',
                toDate: '',
              },
              columns: ['包含','不包含','等于', '不等于', '大于等于', '小于等于', '大于', '小于'],
              showPicker: false,
              showTimePicker: false,
              showCalendar: false,
              selectWords: false,
              tabActive: 0,
              formList: [],
              wordsList: [],
              selectebList: [],
              selectWord: [],
              selectWordIds: [],
              fixList: [],
              pickerIndex: 0,
              datePickerType: 'date',
              currentDate: new Date(),
              logicrelations: [{id:'like',text:'包含'},{id:'notlike',text:'不包含'},{id:'=',text:'等于'},{id:'$ne',text:'不等于'},{id:'$gte',text:'大于等于'},{id:'$lte',text:'小于等于'},{id:'$gt',text:'大于'},{id:'$lt',text:'小于'}]
            }
        },
        computed: {
            receive() {
                return /^(todo|done|copy)$/.test(this.type)
            },
            send() {
                return /^(ongoing|end)$/.test(this.type)
            },
            draft() {
                return this.type == 'draft'
            },
            parsedDate() {
                if (!this.searchJson.formDate || !this.searchJson.toDate) return ''
                const formDate = formatDateTime(this.searchJson.formDate, 'yyyy-MM-dd')
                const toDate = formatDateTime(this.searchJson.toDate, 'yyyy-MM-dd')
                return `${formDate}至${toDate}`
            },
            statusArr() {
                const STATUS_ARR = [
                    {id: '', text: '全部'},
                    {id: 'send', text: '进行中'},
                    {id: 'end', text: '已办结'},
                    {id: 'finish', text: '已中止'},
                    {id: 'back', text: '已退回'},
                    {id: 'draft', text: '已撤回'},
                    {id: 'revoke', text: '已撤销'}
                ]

                let result = []
                switch (this.type) {
                    case 'todo':
                    case 'ongoing':
                        result = [STATUS_ARR[0], STATUS_ARR[1], STATUS_ARR[4]]
                        break
                    case 'done':
                        result = [STATUS_ARR[0], STATUS_ARR[1], STATUS_ARR[2], STATUS_ARR[3], STATUS_ARR[4], STATUS_ARR[5]]
                        break
                    case 'copy':
                        result = [STATUS_ARR[0], STATUS_ARR[1], STATUS_ARR[2], STATUS_ARR[3], STATUS_ARR[4], STATUS_ARR[6]]
                        break
                    case 'end':
                        result = [STATUS_ARR[0], STATUS_ARR[2], STATUS_ARR[3], STATUS_ARR[6]]
                        break
                }
                return result
            }
        },
        created() {
          this.$nextTick(() => {
            if (this.innerSearchJson && this.innerSearchJson != 'undefined' && this.innerSearchJson.length>0) {
              this.searchJson = JSON.parse(decodeURIComponent(this.innerSearchJson));
            }
            this.getForm();
          })
        },
        methods: {
          getForm() {
            getFormList({id: this.flowId, type: 'version'}).then(res => {
              this.formList = res;
              if(this.searchFieldJson && this.searchFieldJson != 'undefined' && this.searchFieldJson.form_id){
                this.formList.forEach((item, index) => {
                  if (item.formId == this.searchFieldJson.form_id){
                    this.tabActive = index;
                    return
                  }
                })
              }
              if (this.formList.length > 0) {
                this.getWords(this.formList[0].formId);
              }
            })
          },
          getWords(id) {
            this.wordsList = [];
            if (this.searchFieldJson && this.searchFieldJson != 'undefined' && this.searchFieldJson.length>0) {
              this.fixList = JSON.parse(decodeURIComponent(this.searchFieldJson)).forms;
            }
            this.fixList.forEach(item => {
              this.logicrelations.forEach(logItem => {
                if (item.logicrelation == logItem.id) {
                  item.logicrelationName = logItem.text;
                  return
                }
              })
            })
            getWordsList({formId: id}).then(res => {
              if(res && res.length>0) {
                res.forEach(item => {
                  let params = {
                    name: '',
                    form_id: '',
                    field: '',
                    field_type: '',
                    logicrelationName: '',
                    logicrelation: '',
                    value: ''
                  }
                  let fldexttype = item.fldexttype;
                  params.name = item.cnfield? item.cnfield : '';
                  params.field = item.enfield? item.enfield : '';
                  params.form_id = item.formid? item.formid : '';
                  if(fldexttype.indexOf("timespinner") != -1){
                    params.field_type = "t";
                  }else if (fldexttype.indexOf("datepicker") != -1){
                    params.field_type = "d";
                  }else if (fldexttype.indexOf("datetimepicker") != -1){
                    params.field_type = "dt";
                  }else if (item.fldtype == "mini-spinner"){
                    params.field_type = "n";
                  }else if (fldexttype.indexOf("combobox") != -1 || fldexttype.indexOf("buttonedit") != -1 || fldexttype.indexOf("checkboxlist") != -1 || fldexttype.indexOf("radiobuttonlist") != -1 || fldexttype.indexOf("coordinate") != -1){
                    params.field_type = "p";
                  }else{
                    params.field_type = "c";
                  }
                  this.fixList.forEach(fixitem => {
                    if (fixitem.field == params.field) {
                      fixitem.name = params.name;
                      this.selectWord.push(fixitem);
                      return
                    }
                  })
                  this.wordsList.push(params);
                })
              }
            })
          },
          openPicker(index) {
            this.pickerIndex = index;
            this.showPicker = true;
          },
          openTimePicker(index) {
            this.pickerIndex = index;
            if (this.fixList[index].field_type == 'dt') {
              this.datePickerType = 'datetime';
            } else {
              this.datePickerType = 'date';
            }
            this.showTimePicker = true;
          },
          wordsOpen() {
            this.selectWord = this.fixList;
            this.selectWordIds = [];
            this.fixList.forEach(item => {
              this.selectWordIds.push(item.field);
            })
            this.selectWords = !this.selectWords;
          },
          tabsChange() {
            let id = this.formList[this.tabActive].formId;
            this.getWords(id)
          },
          wordHandle(item) {
            let index = this.selectWord.indexOf(item);
            if(index == -1) {
              if (this.selectWord.length >= 5) {
                Toast({
                  message: '最多只能选5个'
                });
              } else {
                this.selectWord.push(item);
                this.selectWordIds.push(item.field);
              }
            } else {
              this.selectWord.splice(index,1);
              this.selectWordIds.splice(index,1);
            }
          },
          reset() {
            this.selectWord = [];
            this.selectWordIds = [];
          },
          fixHandle() {
            this.fixList = [];
            let array = this.selectWord;
            array.forEach(item => {
              this.fixList.push(item);
            })
            this.selectWords = false;
          },
          onCalenderConfirm(date) {
            const [start, end] = date
            const format = "yyyy-MM-dd'T'HH:mm:ss"
            this.showCalendar = false
            this.searchJson.formDate = formatDateTime(start, format)
            this.searchJson.toDate = formatDateTime(end, format)
          },
          onSubmit() {
            // field: '',
            let searchFieldJson = {
              form_id: this.formList[this.tabActive].formId,
              field_type: '',
              field: '',
              logicrelation: '',
              textValue: '',
              timeValue:'1970-01-01T00:00:00',
              dateValue: '',
              dataTimeValue: '',
              forms: []
            }
            this.fixList.forEach(item => {
              let formItem = {
                form_id: item.form_id,
                field: item.field,
                field_type: item.field_type,
                logicrelation: item.logicrelation,
                value: item.value
              }
              searchFieldJson.field = item.field;
              searchFieldJson.field_type = item.field_type;
              searchFieldJson.logicrelation = item.logicrelation;
              searchFieldJson.textValue = item.value;
              searchFieldJson.forms.push(formItem)
            })
            let params = {
              type: this.type,
              flowKey: this.flowKey,
              searchJson: encodeURIComponent(JSON.stringify(this.searchJson)),
              searchFieldJson: encodeURIComponent(JSON.stringify(searchFieldJson))
            }
            this.$router.push({
              name: 'FLOW_LIST',
              params: params
            })
          },
          onConfirm(value) {
            this.logicrelations.forEach(item => {
              if (item.text == value) {
                this.fixList[this.pickerIndex].logicrelation = item.id;
                return
              }
            })
            this.fixList[this.pickerIndex].logicrelationName = value;
            this.showPicker =false;
          },
          onTimeConfirm(value) {
            let format = ''
            if(this.fixList[this.pickerIndex].field_type == 'dt') {
              format = 'yyyy-MM-dd HH:mm';
            } else {
              format = 'yyyy-MM-dd';
            }
            this.fixList[this.pickerIndex].value = formatDateTime(value, format);
            this.showTimePicker =false;
          }
        }
    }
</script>

<style lang="scss">
    .flow-list-search {
        padding: 10px 15px;

        .van-radio--horizontal {
            margin-top: 5px;
            margin-bottom: 5px;
        }
    }
    .form-box{
      margin-top: 15px;
      padding-bottom: 10px;
      border-radius: 5px;
      background: #fff;
      h4{
        font-weight: 500;
        font-size: 16px;
        padding:15px 15px;
        position:relative;
        i{
          display: inline-block;
          width: 8px;
          height: 8px;
          border-top: 1px solid #666;
          border-right: 1px solid #666;
          transform: rotate(45deg);
          position: absolute;
          top: 17px;
          right: 15px;
        }
      }
      ul{
        li{
          display: flex;
          padding: 0 15px;
          margin: 5px 0;
          label{
            width: 5em;
            height: 40px;
            line-height: 40px;
            padding-right: 1px;
            flex-shrink: 0;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .tj-field{
            width: 90px;
            height: 40px;
            line-height: 30px;
            padding:5px;
            flex-shrink: 0;
            border: 1px solid #e5e5e5;
            border-radius: 3px;
            input{
              text-align: center;
            }
          }
          .tjz-field{
            height: 40px;
            line-height: 30px;
            margin-left: 15px;
            padding:5px;
            border: 1px solid #e5e5e5;
            border-radius: 3px;
            input{
              text-align: center;
            }
          }
        }
      }
    }
    .van-tabs#formBoxItem{
      .van-tab {
        height: 37px;
        line-height: 35px;
        padding: 0 5px;
        span{
          padding: 0 15px;
          color: #999;
          border:1px solid #e5e5e5;
          border-radius: 3px;
          max-width: 10em;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &.van-tab--active{
          span{
            border: 1px solid var(--main-color);
            color: var(--main-color);
          }
        }
      }
      .van-tabs--line .van-tabs__wrap {
        height: auto !important;
      }
      .van-tabs__nav.van-tabs__nav--line.van-tabs__nav--complete{
        height: 35px;
      }
      .van-tabs__line{
        display: none !important;
      }
    }
    .word-selector{
      width: 100%;
      padding: 15px 15px 60px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 100;
      background: #fff;
      .form-words-box{
        overflow: hidden;
        clear: both;
        span{
          float: left;
          display: inline-block;
          height: 30px;
          line-height: 30px;
          padding:0 20px;
          margin-right: 15px;
          margin-bottom: 15px;
          background: #f1f1f1;
          font-size: 14px;
          color: #999;
          border: 1px solid #e5e5e5;
          border-radius: 3px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: relative;
          &.selected{
            color: #333;
            border-color: var(--main-color);
            background: #fff;
            &:after{
              content: "X";
              display: inline-block;
              width: 15px;
              height: 15px;
              line-height: 1.2em;
              text-align: right;
              font-size: 8px;
              color: #fff;
              position: absolute;
              top:0;
              right: 0;
              z-index: 1;
            }
            &:before{
              content: '';
              display: inline-block;
              border: 8px solid transparent;
              border-top-color: var(--main-color);
              border-right-color: var(--main-color);
              position: absolute;
              top: 0;
              right: 0;
            }
          }
        }
      }
      .btn-box{
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        .van-button{
          width: 35%;
          box-sizing: border-box;
        }
        .van-button:last-of-type{
          width: 65%;
          padding: 0;
        }
      }
    }
</style>
